import { createElement, forwardRef, } from "react";
import { variants, classNames, } from "./index.js";
export function variantProps(config) {
    const variantClassName = variants(config);
    return (props) => {
        const result = {};
        // Pass-through all unrelated props
        for (let prop in props) {
            if (config.variants && !(prop in config.variants)) {
                result[prop] = props[prop];
            }
        }
        // Add the optionally passed className prop for chaining
        result.className = classNames.combine(variantClassName(props), props.className);
        return result;
    };
}
export function styled(type, config) {
    const styledProps = typeof config === "string"
        ? variantProps({ base: config, variants: {} })
        : variantProps(config);
    const Component = forwardRef(({ as, ...props }, ref) => {
        return createElement(as !== null && as !== void 0 ? as : type, { ...styledProps(props), ref });
    });
    return Component;
}
/**
 * No-op function to mark template literals as tailwind strings.
 */
export const tw = String.raw;
